// BackgroundCarousels.jsx
import React from "react";

const courses1 = [
  { id: 1, tag: "Frontend", title: "React Advanced Patterns", time: 25, learners: 856 },
  { id: 2, tag: "Web Design", title: "CSS Grid & Flexbox", time: 20, learners: 1243 },
  { id: 3, tag: "Backend", title: "Node.js Backend Basics", time: 30, learners: 1567 },
  { id: 4, tag: "Programming", title: "JavaScript Fundamentals", time: 15, learners: 1234 },
  { id: 5, tag: "AI/ML", title: "Machine Learning Quiz", time: 35, learners: 623 },
];

const courses2 = [
  { id: 6, tag: "Programming", title: "Python Data Structures", time: 18, learners: 987 },
  { id: 7, tag: "Frontend", title: "React Hooks Mastery", time: 22, learners: 1123 },
  { id: 8, tag: "Backend", title: "Express.js APIs", time: 28, learners: 1011 },
  { id: 9, tag: "DB", title: "SQL Fundamentals", time: 26, learners: 1422 },
  { id: 10, tag: "DevOps", title: "Docker Basics", time: 24, learners: 763 },
];

const courses3 = [
  { id: 11, tag: "Web", title: "Responsive Layouts", time: 16, learners: 654 },
  { id: 12, tag: "Security", title: "Auth & JWT Essentials", time: 27, learners: 534 },
  { id: 13, tag: "Testing", title: "Jest + RTL Crash Course", time: 21, learners: 875 },
  { id: 14, tag: "Frontend", title: "TypeScript for React", time: 23, learners: 1192 },
  { id: 15, tag: "Cloud", title: "Intro to Serverless", time: 19, learners: 421 },
];

const Row = ({ items, top, speed = 65, direction = "left" }) => {
  const doubled = [...items, ...items]; // seamless loop
  return (
    <div className="bg-row" style={{ top }}>
      <div className="bg-mask">
        <div className="bg-track" style={{ ["--speed"]: `${speed}s` }} data-dir={direction}>
          {doubled.map((c, i) => (
            <article className="bg-quiz-card" key={`${c.id}-${i}`}>
              <div className="bg-tag">{c.tag}</div>
              <h6 className="bg-title">{c.title}</h6>
              <div className="bg-meta">
                <span>⏱ {c.time} min</span>
                <span>👥 {c.learners}</span>
                <span>🧪 Quiz</span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
};

export default function BackgroundCarousels() {
  return (
    <div className="bg-carousel">
      <Row items={courses1} top="22%" speed={62} direction="left" />
      <Row items={courses2} top="47%" speed={68} direction="right" />
      <Row items={courses3} top="72%" speed={74} direction="left" />
    </div>
  );
}
